import fetchSuspensionReasons from './fetch_suspension_reasons';

export default {
  fetchSuspensionReasons,
};
